import * as R from 'ramda'
import Big from 'big.js'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const state = {
  fertilizerItems: {}
}

const mutations = {
  LOAD_FERTILIZER_ITEMS (state, payload) {
    state.fertilizerItems = payload
  },

  DELETE_FERTILIZER_ITEM (state, payload) {
    state.fertilizerItems = R.omit(payload, state.fertilizerItems)
  },

  UPDATE_FERTILIZER_ITEM (state, { id, item }) {
    state.fertilizerItems[id] = item
  },

  ADD_FERTILIZER_ITEM (state, { id, item }) {
    const items = {
      ...state.fertilizerItems,
      [id]: item
    }

    state.fertilizerItems = items
  }
}

const actions = {
  updateFertilizerItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      // make the api call to save a new fertilizer
      // if the user is signed in
      if (getters.signedIn) {
        return api.createFertilizer(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_FERTILIZER_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved for this browser session'
        commit('ADD_FERTILIZER_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      // make the api call to update the fertilizer
      // if the user is signedIn
      if (getters.signedIn) {
        return api.updateFertilizer(jsConn)
          .then((jsConn) => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            commit('UPDATE_FERTILIZER_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.apiParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
        commit('UPDATE_FERTILIZER_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteFertilizerItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteFertilizer(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(response => {
          dispatch('deleteFertilizerItemFromAllCrops', jsConn)
          commit('DELETE_FERTILIZER_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Fertilizer item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteFertilizerItemFromAllCrops', jsConn)
      commit('DELETE_FERTILIZER_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  fertilizerItems: state => state.fertilizerItems,

  fertilizerItemsIdList: state => {
    return Object.keys(state.fertilizerItems)
  },

  fertilizerItemsList: (state, getters, rootState, rootGetters) => {
    const itemsList = getters.fertilizerItemsIdList.map((id) => {
      const item = getters.getFertilizerItemById(id)
      const convertUnit = rootGetters.getConvertUnitItemById(item.convertUnitId)

      return {
        id: id,
        description: item.description,
        cost: item.cost,
        fromUnit: convertUnit.fromUnit,
        toUnit: convertUnit.toUnit,
        defaultApplicationRate: item.defaultApplicationRate,
        appliedCost: new Big(item.cost).div(convertUnit.quantity).toFixed(4)
      }
    })

    return itemsList
  },

  getFertilizerItemById: (state) => (id) => {
    return state.fertilizerItems[id]
  }
}

const fertilizerModule = {
  state,
  mutations,
  actions,
  getters
}

export default fertilizerModule
